module.exports = __webpack_public_path__ + "static/media/SF-4-A (1).194332ce.mp3";